// Configurable tooltip copy — replace freely, no code changes elsewhere required.
export const LIEFERTERMINTREUE_TIMELINE_INFO_TEXT =
  "Diese Kachel zeigt, wie viele abgeschlossene Aufträge pro Tag ihren Soll-Termin " +
  "eingehalten haben. Ein Auftrag fließt genau einmal in die Kurve ein — an dem Tag, an dem " +
  "er tatsächlich abgeschlossen wurde — und wird als pünktlich oder verspätet eingestuft, je " +
  "nachdem ob sein Ist-Termin vor/an oder nach seinem Soll-Termin liegt. Noch offene " +
  "Aufträge fließen nicht ein, solange sie nicht abgeschlossen sind. Da einzelne Tage oft nur " +
  "wenige Abschlüsse haben, wird zusätzlich zur rohen Tagesquote eine geglättete Quote über " +
  "ein gleitendes Zeitfenster gezeigt — die Stichprobengröße (N) dieses Fensters steht im " +
  "Tooltip des Diagramms.";
